import { MShopAppCommunityF } from '../../../../../../modules/MShop/App/Community/F/Function/module/MShopAppCommunityF';
import { FanLetterCommentUser } from '../../../components/cells/FanLetterItem/FanLetterItemView';
import { FanLetterItemOpenDetailEvent } from '../../../components/cells/FanLetterItem/event/FanLetterItemEvent';
import { $ } from 'rune-ts';

export const openFanLetterDetail = ({
  element,
  fan_letter_id,
  fan_letter_item_view,
}: FanLetterItemOpenDetailEvent['detail']) => {
  return MShopAppCommunityF.openDetail({
    article_id: fan_letter_id,
    parent_cont_el: element ? $(element).parentNode()?.element() : null,
    parent_items: element ? [element] : [],
    no_replace_url: false,
    title: ET('creator_shop::fan_letters::title'),
    is_product_review: false,
    is_list: false,
    is_rune: true,
    closingWithRune: (
      article_id: number,
      is_like: boolean,
      like_count: number,
      comment_count: number,
      comment_users: FanLetterCommentUser[],
    ) => {
      if (article_id && fan_letter_item_view) {
        return fan_letter_item_view
          .setIsLike(is_like)
          .setLikeCount(like_count)
          .setCommentCount(comment_count)
          .setCommentUsers(comment_users)
          .redraw();
      }
    },
  });
};
